import { WPSClient, getWidgetProps, safeBool } from 'DVWebNodeUtils';
import  { RetailNavWidget } from './components/RetailNavWidget'
import transformNav from './transforms/RetailNav';
import { RetailNavProps } from './types'
import { prepareRetailNavResponseFallback, GetProfilesResponseFallback } from './mocks/RetailNavFallback'

require('./index.module.scss');
// Client-side only Javascript
if (!global.__SERVER__) {
    require('./scripts/retail-nav')
}

const ProfilePropsFallback = {
    isCerberusEnabled: false,
    data: GetProfilesResponseFallback
}

const getProps: getWidgetProps<RetailNavProps> =
    global.__SERVER__ === true
        ? async ({ context, isProfilesEnabled }, api) => {
              const isCerberusEnabled = safeBool(isProfilesEnabled)
              const wpsClient = new WPSClient(api)
              try {
                const [navResponse, getProfilesResponse] = await Promise.all([
                    wpsClient.Navigation({ context }),
                    isCerberusEnabled && wpsClient.GetProfiles({ withAdditionalData: true, context })
                    ])
                return transformNav(
                    context,
                    navResponse,
                    {isCerberusEnabled: isCerberusEnabled,
                        data: getProfilesResponse }
                )
              } catch (exception) {
                /* Return static fallback */
                api.logger.count('DVWebNodeNav-RetailNavFallback', 1, true)
                return transformNav(
                    context,
                    prepareRetailNavResponseFallback(context.marketplaceID),
                    ProfilePropsFallback
                )
              }
          }
        : undefined;

export const RetailNav = {
    name: 'retail-nav',
    getProps,
    Component: RetailNavWidget
};
